export default __webpack_public_path__ + "static/media/AISWAL_et_al_Cytotherapy2017_onlyCD56-enriched donor cell infus.9fcdfbac.pdf";